enum FileTypeGroup {
	ALL = "ALL",
	TEXT = "TEXT",
	HTML = "HTML",
	OFFICE = "OFFICE",
	WORD = "WORD",
	MAIL = "MAIL",
	VCARD = "VCARD",
	VCAL = "VCAL",
	PDF = "PDF",
	IMAGE = "IMAGE"
}

export default FileTypeGroup;